import styled from "styled-components";

export const Container = styled.header`
  height: 116px;
  background: #28262e;
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  width: 80px;
  height: 80px;
  margin-left: 30px;
`;

export const Title = styled.h1`
  font-family: Roboto;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
  margin: auto;
  padding-right: 30px;
`;
